import { NutritionProgramWizard } from "@corpuscomplete/core-ui/nutrition/program/wizard";
import { queries } from "@corpuscomplete/core/zero";
import { ProgramsPage } from "@corpuscomplete/web/modules/nutrition/program/pages/programs";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/programs/")({
  component: ProgramsPage,
  loader: async ({ context }) => {
    const today = Temporal.Now.plainDateISO().toString();
    if (context.zero) {
      NutritionProgramWizard.preload(context.zero, context.actor);
    }
    void context.zero?.run(
      queries.nutritionProgram.onDate({ userId: context.actor.userId, date: today }),
    );
    void context.zero?.run(
      queries.bodyMetricGoal.forTypeOnDate({
        userId: context.actor.userId,
        type: "weight",
        date: today,
      }),
    );
  },
});
